let dispatcher;

export function setToastDispatcher(fn) {
  dispatcher = fn;
}

function ensureDispatcher() {
  if (typeof dispatcher !== 'function') {
    console.warn('Toast provider not mounted yet. Call inside app lifecycle.');
    return false;
  }
  return true;
}

export const toast = {
  success(message, options = {}) {
    if (!ensureDispatcher()) return;
    dispatcher({content: message, error: false, ...options});
  },
  error(message, options = {}) {
    if (!ensureDispatcher()) return;
    dispatcher({content: message, error: true, ...options});
  }
};

if (typeof window !== 'undefined') {
  window.toast = toast;
}
